var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mb-4 w-full user-latest-image",staticStyle:{"height":"auto","width":"auto","max-width":"600px","max-height":"600px"},attrs:{"src":_vm.imageUrl,"alt":"File not found"}})}
var staticRenderFns = []

export { render, staticRenderFns }